/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Search_Tracking_PlaceholderInputs */

const en_samples_search_tracking_placeholder = /** @type {(inputs: Samples_Search_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search tracking...`)
};

const es_samples_search_tracking_placeholder = /** @type {(inputs: Samples_Search_Tracking_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar rastreo...`)
};

/**
* | output |
* | --- |
* | "Search tracking..." |
*
* @param {Samples_Search_Tracking_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_search_tracking_placeholder = /** @type {((inputs?: Samples_Search_Tracking_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Search_Tracking_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_search_tracking_placeholder(inputs)
	return es_samples_search_tracking_placeholder(inputs)
});